import { useActiveOrgProfile } from './useActiveOrgProfile'
import { useGetOrgUserLimit } from '@/services/settings'

export const useCurrentUserOrgLimit = () => {
  const { data: profileData } = useActiveOrgProfile()
  const userId = profileData?.org_user?.user_id
  const { data: limitData } = useGetOrgUserLimit(userId ?? 0)

  return limitData
}
